import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import network from 'network/network'

const initialState = {
    data: {},
    loading: false,
    error: null
}

export const getFirmSettings = createAsyncThunk('firmSettings/getFirmSettings', async () => {
    const response = await network.get("/admin/CoffeeSettings/GetSettings");
    return response.data;
})

export const firmSettingsSlice = createSlice({
    name: 'firmSettings',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getFirmSettings.pending, (state) => {
                state.loading = true;
            })
            .addCase(getFirmSettings.fulfilled, (state, action) => {
                state.loading = false;
                state.data = action.payload;
                state.error = null;

            })
            .addCase(getFirmSettings.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            })
    }
})

export const {  } = firmSettingsSlice.actions;

export default firmSettingsSlice.reducer;